import { useTranslate } from "@opensea/next-translate"
import { Logout } from "@opensea/ui-kit/icons"
import { useLogout } from "@privy-io/react-auth"
import React from "react"
import { useTrackingFn } from "@/lib/analytics/useTrackingFn"
import { useVesselActions } from "@/providers/Vessel00/useVesselActions"
import { SettingsItem } from "./SettingsItem.react"

export function LogoutItem() {
  const t = useTranslate("settings")
  const trackLogout = useTrackingFn("logout")
  const { logout: privyLogout } = useLogout()
  const { logout: vesselLogout, setClickAway } = useVesselActions()

  const handleLogout = async () => {
    trackLogout()
    await privyLogout()
    await vesselLogout()
    await setClickAway(true)
  }

  return (
    <SettingsItem
      icon={<Logout />}
      label={t("logout.label", "Log out")}
      onClick={handleLogout}
    />
  )
}
